module.exports = __webpack_public_path__ + "static/media/radiance.838247e5.png";